import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgNightlifeSolid = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7 2.25a.75.75 0 0 0-.742.644l-1 7A.75.75 0 0 0 5.25 10c0 3.318 2.748 5.435 6 5.718v4.532H8a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5h-3.25v-4.532c3.252-.283 6-2.4 6-5.718a.753.753 0 0 0-.008-.106l-1-7A.75.75 0 0 0 17 2.25H7Zm-.046 6.377L7.65 3.75h8.7l.841 5.892A4.25 4.25 0 0 1 12.45 9.4a5.75 5.75 0 0 0-5.496-.773Z",
  fill: "currentColor"
})));

export { SvgNightlifeSolid as default };
